import { useState } from "react";
import { Button, Input } from "../Form";
import Modal from "./Modal";
import { useForm } from "react-hook-form";
import { HiOutlineLockClosed } from "react-icons/hi";
import ConfirmationAlert from "../ConfirmationAlert";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { changePassword } from "../../redux/features/authSlice"; // Asume que tienes esta acción

function ChangePasswordModal({ open, setOpen, username }) {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
  } = useForm();

  const onSubmit = async (data) => {
    ConfirmationAlert({
      title: "Cambiar Contraseña",
      text: "¿Estás seguro que deseas cambiar tu contraseña?",
      onAccept: async () => {
        try {
          setIsLoading(true);
          const result = await dispatch(changePassword(data)).unwrap();

          toast.success("Contraseña cambiada exitosamente");
          setOpen(false);
          reset(); // Limpiar el formulario

          // Cerrar sesión después de cambiar contraseña (opcional)
          // await dispatch(logout());
          // navigate("/login");
        } catch (error) {
          toast.error(error.message || "Error al cambiar la contraseña");
        } finally {
          setIsLoading(false);
        }
      },
    });
  };

  return (
    <Modal
      title="Cambiar Contraseña"
      isOpen={open}
      closeModal={() => {
        reset();
        setOpen(false);
      }}
      width={"max-w-md"}
    >
      <div className="flex flex-col gap-4">
        <div className="text-center mb-4">
          <p className="font-medium">Usuario: {username}</p>
        </div>

        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          <Input
            label="Contraseña Actual"
            type="password"
            color={true}
            Icon={HiOutlineLockClosed}
            register={register("current_password", {
              required: "Este campo es requerido",
              minLength: {
                value: 6,
                message: "Mínimo 6 caracteres",
              },
            })}
            error={errors.current_password}
          />

          <Input
            label="Nueva Contraseña"
            type="password"
            color={true}
            Icon={HiOutlineLockClosed}
            register={register("new_password", {
              required: "Este campo es requerido",
              minLength: {
                value: 6,
                message: "Mínimo 6 caracteres",
              },
              validate: (value) =>
                value !== watch("current_password") ||
                "La nueva contraseña debe ser diferente a la actual",
            })}
            error={errors.new_password}
          />

          <Input
            label="Confirmar Nueva Contraseña"
            type="password"
            color={true}
            Icon={HiOutlineLockClosed}
            register={register("new_password_confirmation", {
              required: "Este campo es requerido",
              validate: (value) =>
                value === watch("new_password") ||
                "Las contraseñas no coinciden",
            })}
            error={errors.new_password_confirmation}
          />

          <div className="pt-4">
            <Button
              type="submit"
              label={isLoading ? "Procesando..." : "Cambiar Contraseña"}
              Icon={HiOutlineLockClosed}
              disabled={isLoading}
              className="w-full"
            />
          </div>
        </form>
      </div>
    </Modal>
  );
}

export default ChangePasswordModal;
